module.exports = function() {
  return new Worker(__webpack_public_path__ + "bf041164eee4aef2ade1.worker.js");
};